import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

export const httpFetchTransactions = (
  currencyType: string,
  transactionType: string,
  place?: string,
  crypto?: string,
  limit?: number,
  page?: number,
  status?: string,
) => {
  return get(
    `support/transactions/fetch?currencyType=${encodeParam(currencyType)}&transactionType=${encodeParam(transactionType)}&crypto=${encodeParam(crypto)}&place=${encodeParam(place)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}&status=${encodeParam(status)}`,
  );
};

export const httpVendorDeposits = (type: string) => {
  return get(
    `support/merchants/deposits?type=${encodeParam(type.replace("completed", "successful"))}`,
  );
};

export const httpVendorDeposit = (id: number) => {
  return get(`support/merchants/deposit/${encodeParam(id)}`);
};

export const httpFetchPlanTransactions = (id: number, crypto?: string) => {
  return get(
    `support/transactions/fetchPlanTransactions/${encodeParam(id)}?crypto=${encodeParam(crypto)}`,
  );
};

export const httpUSearchTransaction = (id: string, signal?: AbortSignal) => {
  return get(`support/transactions/search?search=${encodeParam(id)}`, signal);
};

export const httpFetchVouchers = (
  filter: string,
  limit?: number,
  page?: number,
) => {
  return get(
    `support/transactions/vouchers?filter=${encodeParam(filter)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};
